import { Button, Form, Input, Table, message } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fetchLanguages } from "./FetchLanguages";
import { EditOutlined } from "@ant-design/icons";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { create_language, update_language } from "../../endpoints/API";

const Language = () => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [languages, setLanguages] = useState([]); // State to store language data
  const isUser = useSelector((state) => state.user.user); // Fetch user data from Redux
  const [form] = Form.useForm(); // Create form instance
  const [editingId, setEditingId] = useState(null); // State to track which language is being edited

  useEffect(() => {
    fetchLanguages(setLanguages, baseUrl, prodTestUrl); // Call the fetch function on mount
  }, []); // Empty dependency array to run only on mount

  const onFinish = async (values) => {
    try {
      const payload = {
        language: values.language.trim(), // Trim whitespace from language name
        created_by: isUser.user_id, // User ID from Redux state
        ...(editingId && { id: editingId }), // Include editing ID if present
      };

      let response;

      if (editingId) {
        response = await update_language(payload);
      } else {
        response = await create_language(payload);
      }

      if (response.statusText=="OK") {
        const data =response?.data;

        // Show success message
        message.success(
          editingId
            ? "Language updated successfully!"
            : "Language created successfully!"
        );

        // Fetch updated list of languages
        fetchLanguages(setLanguages, baseUrl, prodTestUrl); // Call fetchLanguages again to refresh the list

        // Reset form fields
        form.resetFields(); // Reset input field after successful creation or update
        setEditingId(null); // Reset editing ID after submission
      } else {
        message.error("Language already exists.");
      }
    } catch (error) {
      message.error(error?.response?.data?.error||"An error occurred while creating/updating the language.");
    }
  };

  const handleEdit = (record) => {
    setEditingId(record.id); // Set the ID of the language being edited
    form.setFieldsValue({
      language: record.name, // Set input field with the selected language name
    });
  };

  const columns = [
    {
      title: "Language",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Edit",
      key: "edit",
      render: (text, record) => (
        <Button onClick={() => handleEdit(record)}>
          <EditOutlined />
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Form form={form} onFinish={onFinish}>
        <div
          className="border flex gap-5 p-4 items-center rounded-lg shadow-md"
          style={{ padding: "16px" }}
        >
          <Form.Item
            label={<span className="font-semibold">Add Language</span>}
            name="language"
            rules={[{ required: true, message: "Please enter a language!" }]}
            style={{ margin: "0" }} // Reset margin for Form.Item
          >
            <Input placeholder="Enter language" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item style={{ margin: "0" }}>
            {/* Reset margin for Form.Item */}
            <Button type="primary" htmlType="submit">
              {editingId ? "Update" : "Save"}{" "}
              {/* Change button text based on editing state */}
            </Button>
          </Form.Item>
        </div>
      </Form>

      <Table
        dataSource={languages} // Set dataSource to the languages state
        columns={columns}
        rowKey="id" // Use id as the unique key for rows (assuming id is available)
      />
    </div>
  );
};

export default Language;
